module.exports = __webpack_public_path__ + "img/placeholder.99b71231.png";